/* eslint-disable class-methods-use-this */
/* eslint-disable react/forbid-prop-types */
import React, { PureComponent } from 'react';
import { hideVisually } from 'polished';
import PropTypes from 'prop-types';
import { List as MaterialList, CircularProgress } from '@material-ui/core';
import AssignmentCard from '../AssignmentCard/AssignmentCard';
import {
  Container,
  OuterContainer,
  LogoImage,
  LoaderContainer,
  DeleteIcon,
  ExportIcon,
  deleteTextClass,
  Visibility,
  VisibilityOff,
  Edit,
  Lock,
  LockOpen,
  People,
  EmptyBox,
  EmptyBg,
  Image,
  EmptyTitle,
  EmptySubTitle,
} from './List.styled';
import launchHandin from '../utils/launchHandin';
import launchManualAssignment from '../utils/launchManualAssignment';
import TurnitinModal from '../TurnitinModal';
import HandinLogo from '../../../../../../static/handin-logo.svg';
import TurnitinLogo from '../../../../../../static/turnitin.png';
import {
  TURNITIN_PROVIDER,
  HANDIN_PROVIDER,
  MANUAL,
  gradeTypeDisplays,
} from '../constants';
import emptyImage from '../../../../../../static/Search_Empty.svg';
import { STATUS, getStatus, getGradeAndSubmittedProps } from './utils';
import Scrollbar from '../../../common/ScrollBar';

const ProviderConfig = {
  'hand-in': {
    title: 'Handin',
    image: HandinLogo,
  },
  handin: {
    title: 'Handin',
    image: HandinLogo,
  },
  turnitin: {
    title: 'Turnitin',
    image: TurnitinLogo,
  },
};

export const LogoComponent = (imageSrc) => () => (
  <LogoImage width="24px" height="24px" src={imageSrc} alt="assignment" />
);

const isGroupAssignment = ({ groupSet }) => !!groupSet;

class List extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { turnitinLaunch: null };

    this.launchAssignment = this.launchAssignment.bind(this);
    this.exportGrades = this.exportGrades.bind(this);
    this.launchTurnitin = this.launchTurnitin.bind(this);
    this.renderEmpty = this.renderEmpty.bind(this);
    this.renderAssignmentCard = this.renderAssignmentCard.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderErrorState = this.renderErrorState.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.renderManualAssignment = this.renderManualAssignment.bind(this);
    this.closeTurnItIn = this.closeTurnItIn.bind(this);
  }

  getVisibilityMenuItem(assignment) {
    const {
      user,
      selectedSpace,
      unhideAssignment,
      hideAssignment,
      isEducator,
    } = this.props;

    if (!isEducator) {
      return null;
    }

    return assignment.isHidden
      ? {
          id: 'show-assignment',
          text: 'Show assignment',
          icon: Visibility,
          onClick: () =>
            unhideAssignment(user, selectedSpace.objectId, assignment),
        }
      : {
          id: 'hide-assignment',
          text: 'Hide assignment',
          icon: VisibilityOff,
          onClick: () =>
            hideAssignment(user, selectedSpace.objectId, assignment),
        };
  }

  getToggleCloseMenuItem({ status, assignment }) {
    const {
      user,
      selectedSpace: { objectId: spaceId },
      closeAssignment,
      reopenAssignment,
      isEducator,
    } = this.props;

    if (!isEducator || assignment.provider !== HANDIN_PROVIDER) {
      return null;
    }

    return status === STATUS.closed
      ? {
          id: 're-open',
          text: 'Re-open',
          onClick: () => reopenAssignment(user, spaceId, assignment),
          icon: LockOpen,
        }
      : {
          id: 'close',
          text: 'Close',
          onClick: () => closeAssignment(user, spaceId, assignment),
          icon: Lock,
        };
  }

  getToggleAnonymizeMenuItem(assignment) {
    const {
      user,
      selectedSpace: { objectId: spaceId },
      anonymiseStudents,
      revealStudents,
      isEducator,
    } = this.props;

    if (!isEducator || assignment.provider !== HANDIN_PROVIDER) {
      return null;
    }

    return assignment.isAnonymised
      ? {
          id: 'reveal-students',
          text: 'Reveal students',
          onClick: () => revealStudents(user, spaceId, assignment),
          icon: People,
        }
      : {
          id: 'anonymise-students',
          text: 'Anonymise students',
          onClick: () => anonymiseStudents(user, spaceId, assignment),
          icon: People,
        };
  }

  launchAssignment(assignment) {
    const {
      selectedSpace: { objectId: selectedSpaceId },
      goToSubmissions,
      isEducator,
      accessingAsStaff,
    } = this.props;

    const openSubmissionsInAula = () =>
      goToSubmissions({
        spaceId: selectedSpaceId,
        assignmentId: assignment.id ? assignment.id : assignment.objectId,
      });
    if (isEducator || accessingAsStaff) {
      openSubmissionsInAula();
      return;
    }

    switch (assignment.provider) {
      case HANDIN_PROVIDER:
        launchHandin({
          assignmentId: assignment.externalId,
          spaceId: assignment.classRoom
            ? assignment.classRoom.objectId
            : selectedSpaceId,
        });
        break;
      case TURNITIN_PROVIDER:
        this.launchTurnitin(assignment);
        break;
      default:
        break;
    }
  }

  exportGrades(assignment) {
    return () => {
      const { selectedSpace, exportGrades } = this.props;
      const { classRoom } = assignment;
      const spaceId = classRoom ? classRoom.objectId : selectedSpace.objectId;

      exportGrades({
        assignment,
        spaceId,
      });
    };
  }

  launchTurnitin(assignment) {
    this.setState({
      turnitinLaunch: assignment,
    });
  }

  closeTurnItIn() {
    this.setState({ turnitinLaunch: null });
  }

  renderLoader() {
    return (
      <Container>
        <LoaderContainer>
          <CircularProgress size="24px" />
        </LoaderContainer>
      </Container>
    );
  }

  renderEmpty() {
    const { assignments, searchQuery } = this.props;

    if (!assignments.length) {
      const title = searchQuery ? 'Oops! No matches' : 'No assignments';

      const subTitle = searchQuery
        ? 'No assignment in your search match any assignments.'
        : 'This space contains no assignments currently.';

      return (
        <EmptyBox>
          <EmptyBg>
            <Image
              width="220px"
              height="220px"
              src={emptyImage}
              alt="no_assignments"
            />
            <EmptyTitle tabIndex="-1" aria-live="polite">
              {title}
            </EmptyTitle>
            <EmptySubTitle>{subTitle}</EmptySubTitle>
          </EmptyBg>
        </EmptyBox>
      );
    }

    return null;
  }

  renderErrorState() {
    const { isErrored } = this.props;

    if (isErrored) {
      const title = 'Unable to fetch assignments';
      const subTitle = 'Refresh the page to try again!';

      return (
        <EmptyBox>
          <EmptyBg>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptySubTitle>{subTitle}</EmptySubTitle>
          </EmptyBg>
        </EmptyBox>
      );
    }

    return null;
  }

  renderManualAssignment(assignment) {
    const {
      isEducator,
      selectedSpace: { objectId: selectedSpaceId },
    } = this.props;
    const { gradeType, submission } = assignment;

    const customFooter = `${gradeTypeDisplays[gradeType]} grading`;

    // block is only clickable for educator
    const handleContentClick = isEducator
      ? () =>
          launchManualAssignment({
            assignmentId: assignment.id,
            spaceId: selectedSpaceId,
          })
      : undefined;

    // not reuse `getGradeAndSubmittedProps` to avoid displaying `Submitted` status
    const grade =
      submission && submission.length ? submission[0].displayGrade : undefined;

    return (
      <AssignmentCard
        {...assignment}
        dueDate={assignment.endDate}
        key={assignment.id}
        status="manualAssignment"
        isEducator={isEducator}
        dense
        onContentClick={handleContentClick}
        customFooter={customFooter}
        grade={grade}
      />
    );
  }

  renderAssignmentCard(assignment) {
    const {
      user,
      selectedSpace: { objectId: spaceId },
      onEditAssignment,
      deleteAssignment,
      isEducator,
      accessingAsStaff,
    } = this.props;

    if (assignment.provider === MANUAL) {
      return this.renderManualAssignment(assignment);
    }

    const providerConfig = ProviderConfig[assignment.provider];

    if (!providerConfig) {
      // Provider not supported
      return null;
    }

    const logo = LogoComponent(providerConfig.image);
    const assignmentStatus = getStatus(assignment);
    const menuItems = [
      this.getVisibilityMenuItem(assignment),
      isEducator && {
        id: 'edit',
        text: 'Edit',
        onClick: () => onEditAssignment(assignment),
        icon: Edit,
      },
      (isEducator || accessingAsStaff) && {
        id: 'export-grades',
        text: 'Export grades',
        onClick: this.exportGrades(assignment),
        icon: ExportIcon,
      },
      this.getToggleCloseMenuItem({
        assignment,
        status: assignmentStatus,
      }),
      this.getToggleAnonymizeMenuItem(assignment),
      isEducator && {
        id: 'delete',
        text: 'Delete',
        onClick: () => deleteAssignment(user, spaceId, assignment),
        icon: DeleteIcon,
        textClass: deleteTextClass,
      },
    ].filter((item) => !!item);

    return (
      <AssignmentCard
        {...assignment}
        dueDate={assignment.endDate}
        key={assignment.objectId}
        status={assignmentStatus}
        displayDate="endDate"
        isEducator={isEducator}
        dense
        menuItems={menuItems}
        Logo={logo}
        {...getGradeAndSubmittedProps(isEducator, assignment)}
        onContentClick={() => this.launchAssignment(assignment)}
        isGroupAssignment={isGroupAssignment(assignment)}
      />
    );
  }

  renderList() {
    const { user, selectedSpace, assignments, isEducator } = this.props;

    const { turnitinLaunch } = this.state;

    if (!assignments.length) {
      return null;
    }

    return (
      <MaterialList data-testid="assignment-list">
        <span
          aria-live="polite"
          style={{ ...hideVisually() }}
        >{`${assignments.length} assignments found`}</span>
        {assignments.map(this.renderAssignmentCard)}
        {turnitinLaunch && (
          <TurnitinModal
            key={turnitinLaunch}
            user={user}
            assignment={turnitinLaunch}
            space={selectedSpace}
            isEducator={isEducator}
            onClose={this.closeTurnItIn}
          />
        )}
      </MaterialList>
    );
  }

  renderContent() {
    const {
      isFetching,
      isErrored,
      assignments,
      hasFetchedAssignments,
    } = this.props;

    if (isFetching && !hasFetchedAssignments) {
      return this.renderLoader();
    }

    if (isErrored) {
      return this.renderErrorState();
    }

    if (!assignments.length) {
      return this.renderEmpty();
    }

    return this.renderList();
  }

  render() {
    const { accessToken } = this.props;

    if (!accessToken) {
      return this.renderLoader();
    }

    return (
      <OuterContainer>
        <Scrollbar autoHide style={{ height: '100%' }}>
          <Container>{this.renderContent()}</Container>
        </Scrollbar>
      </OuterContainer>
    );
  }
}

List.propTypes = {
  user: PropTypes.object.isRequired,
  assignments: PropTypes.array,
  isFetching: PropTypes.bool,
  hasFetchedAssignments: PropTypes.bool,
  isErrored: PropTypes.bool,
  searchQuery: PropTypes.string,
  selectedSpace: PropTypes.object,
  isEducator: PropTypes.bool.isRequired,
  accessingAsStaff: PropTypes.bool.isRequired,
  unhideAssignment: PropTypes.func.isRequired,
  hideAssignment: PropTypes.func.isRequired,
  closeAssignment: PropTypes.func.isRequired,
  reopenAssignment: PropTypes.func.isRequired,
  anonymiseStudents: PropTypes.func.isRequired,
  revealStudents: PropTypes.func.isRequired,
  deleteAssignment: PropTypes.func.isRequired,
  exportGrades: PropTypes.func.isRequired,
  goToSubmissions: PropTypes.func.isRequired,

  onEditAssignment: PropTypes.func.isRequired,
  accessToken: PropTypes.string,
};

List.defaultProps = {
  selectedSpace: {},
  isFetching: false,
  hasFetchedAssignments: false,
  isErrored: false,
  assignments: [],
  searchQuery: null,
  accessToken: undefined,
};

export default List;
